import { render, staticRenderFns } from "./BookBox.vue?vue&type=template&id=2640108e&scoped=true"
import script from "./BookBox.vue?vue&type=script&lang=js"
export * from "./BookBox.vue?vue&type=script&lang=js"
import style0 from "./BookBox.vue?vue&type=style&index=0&id=2640108e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640108e",
  null
  
)

export default component.exports